export default __webpack_public_path__ + "static/media/facebook.51db46b2.svg";